// src/routes/sales-team/bagspa_views.js

// Dashboard
import DashboardHome from '../../pages/DashboardHome/DashboardHome.jsx'
import UpdatePasswordPage from 'domains/admin/pages/update-password-page/update-password-page.jsx'

// Customers
import CustomerListPage   from '../../pages/customers/CustomerListPage/CustomerListPage.jsx'
import CustomerDetailPage from '../../pages/customers/CustomerDetailPage/CustomerDetailPage.jsx'
import CustomerFormPage   from '../../pages/customers/CustomerFormPage/CustomerFormPage.jsx'

// Customer Addresses
import CustomerAddressListPage from '../../pages/customers/CustomerAddresses/CustomerAddressListPage.jsx'
import CustomerAddressDetailPage from '../../pages/customers/CustomerAddresses/CustomerAddressDetailPage.jsx'
import CustomerAddressFormPage from '../../pages/customers/CustomerAddresses/CustomerAddressFormPage.jsx'

// Products
import ProductsListPage from '../../pages/products/ProductsListPage/ProductsListPage.jsx'
import ProductDetailPage from '../../pages/products/ProductDetailPage/ProductDetailPage.jsx'
import ProductCreatePage from '../../pages/products/ProductCreatePage/ProductCreatePage.jsx'

// Vouchers
import VouchersListPage  from '../../pages/vouchers/VouchersListPage/VouchersListPage.jsx'
import VoucherDetailPage from '../../pages/vouchers/VoucherDetailPage/VoucherDetailPage.jsx'
import VoucherFormPage   from '../../pages/vouchers/VoucherFormPage/VoucherFormPage.jsx'
import VoucherImportPage from '../../pages/vouchers/VoucherImportPage/VoucherImportPage.jsx'

// Orders
import OrdersListPage from '../../pages/orders/OrdersListPage/OrdersListPage.jsx'
import OrderCreatePage from '../../pages/orders/OrderCreatePage/OrderCreatePage.jsx'
import OrderDetailPage from '../../pages/orders/OrderDetailPage/OrderDetailPage.jsx'

// Payments
import PaymentsListPage from '../../pages/payments/PaymentsListPage/PaymentsListPage.jsx'
import PaymentVerifyPage from '../../pages/payments/PaymentVerifyPage/PaymentVerifyPage.jsx'
import PaymentDetailPage from '../../pages/payments/PaymentDetailPage/PaymentDetailPage.jsx'

// Shipments
import ShipmentsListPage from '../../pages/shipments/ShipmentsListPage/ShipmentsListPage.jsx'
import ShipmentDetailPage from '../../pages/shipments/ShipmentDetailPage/ShipmentDetailPage.jsx'

// Tanda Masuk
import TandaMasukListPage from '../../pages/documents/TandaMasukListPage/TandaMasukListPage.jsx'
import TandaMasukDetailPage from '../../pages/documents/TandaMasukDetailPage/TandaMasukDetailPage.jsx';

import SuratJalanListPage from '../../pages/documents/SuratJalanListPage/SuratJalanListPage.jsx'
import DocumentDetailPage from '../../pages/documents/DocumentDetailPage/DocumentDetailPage.jsx'
import InvoicesListPage from '../../pages/documents/InvoiceListPage/InvoiceListPage.jsx'

// Misc
import CustomerCreatePage from '../../pages/customers/CustomerCreatePage/CustomerCreatePage.jsx'

// Taxonomy hub + pages
import TaxonomyPage from '../../pages/taxonomy/TaxonomyPage/TaxonomyPage.jsx'
import BrandsListPage from '../../pages/taxonomy/Brands/BrandsListPage.jsx'
import BrandsFormPage from '../../pages/taxonomy/Brands/BrandsFormPage.jsx'
import CategoriesListPage from '../../pages/taxonomy/Categories/CategoriesListPage.jsx'
import CategoriesFormPage from '../../pages/taxonomy/Categories/CategoriesFormPage.jsx'
import ColoursListPage from '../../pages/taxonomy/Colours/ColoursListPage.jsx'
import ColoursFormPage from '../../pages/taxonomy/Colours/ColoursFormPage.jsx'
import MaterialsListPage from '../../pages/taxonomy/Materials/MaterialsListPage.jsx'
import MaterialsFormPage from '../../pages/taxonomy/Materials/MaterialsFormPage.jsx'
import SizesListPage from '../../pages/taxonomy/Sizes/SizesListPage.jsx'
import SizesFormPage from '../../pages/taxonomy/Sizes/SizesFormPage.jsx'
import OrderCategoriesListPage from '../../pages/taxonomy/OrderCategories/OrderCategoriesListPage.jsx';
import OrderCategoriesFormPage from '../../pages/taxonomy/OrderCategories/OrderCategoriesFormPage.jsx';
// Orders
import OrderEditPage from '../../pages/orders/OrderEditPage/OrderEditPage.jsx'

// Audit Log QC
import AuditLogPage from '../../pages/audit-log/AuditLogPage.jsx'

// Admin Accounts
import AdminAccountsListPage from '../../pages/admin-accounts/AdminAccountsListPage/AdminAccountsListPage.jsx'
import AdminAccountFormPage from '../../pages/admin-accounts/AdminAccountFormPage/AdminAccountFormPage.jsx'

const LAYOUT = '/app'
const BASE   = '/sales/bagspa'

const bagspa_views = [
  // Dashboard
  { name: 'Dashboard',      icon: 'ni ni-shop',           layout: LAYOUT, path: `${BASE}/dashboard`,  component: DashboardHome },

  // Update Password
  { name: 'Update Password', icon: 'ni ni-lock-circle-open', layout: LAYOUT, path: `${BASE}/update-password`, component: UpdatePasswordPage, invisible: true },

  // Customers
  { name: 'Customers',      icon: 'ni ni-single-02',     layout: LAYOUT, path: `${BASE}/customers`, component: CustomerListPage },
  { name: 'New Customer',                                layout: '/app', path: '/sales/bagspa/customers/new',      component: CustomerFormPage,   invisible: true },
  { name: 'Customer Detail',                             layout: '/app', path: '/sales/bagspa/customers/:id',      component: CustomerDetailPage, invisible: true },
  { name: 'Edit Customer',                               layout: '/app', path: '/sales/bagspa/customers/:id/edit', component: CustomerFormPage,   invisible: true },

  // Customer Addresses
  { name: 'Customer Addresses', layout: LAYOUT, path: `${BASE}/customers/:customerId/addresses`, component: CustomerAddressListPage, invisible: true },
  { name: 'New Address', layout: LAYOUT, path: `${BASE}/customers/:customerId/addresses/new`, component: CustomerAddressFormPage, invisible: true },
  { name: 'Address Detail', layout: LAYOUT, path: `${BASE}/customers/:customerId/addresses/:id`, component: CustomerAddressDetailPage, invisible: true },
  { name: 'Edit Address', layout: LAYOUT, path: `${BASE}/customers/:customerId/addresses/:id/edit`, component: CustomerAddressFormPage, invisible: true },

  // Products
  { name: 'Products',       icon: 'ni ni-box-2',            layout: LAYOUT, path: `${BASE}/products`,            component: ProductsListPage },
  { name: 'New Product',                                    layout: LAYOUT, path: `${BASE}/products/new`,        component: ProductCreatePage,  invisible: true },
  { name: 'Product Detail',                                 layout: LAYOUT, path: `${BASE}/products/:id`,        component: ProductDetailPage,  invisible: true },  

  // Vouchers (NEW)
  { name: 'Vouchers',       icon: 'ni ni-badge',   layout: LAYOUT, path: `${BASE}/vouchers`,            component: VouchersListPage },
  { name: 'Import Vouchers',                      layout: LAYOUT, path: `${BASE}/vouchers/import`,     component: VoucherImportPage, invisible: true },
  { name: 'Voucher Detail',                       layout: LAYOUT, path: `${BASE}/vouchers/:id`,        component: VoucherDetailPage, invisible: true },
  { name: 'Edit Voucher',                         layout: LAYOUT, path: `${BASE}/vouchers/:id/edit`,   component: VoucherFormPage,   invisible: true },

  // Orders
  { name: 'Orders',         icon: 'ni ni-basket',           layout: LAYOUT, path: `${BASE}/orders`,              component: OrdersListPage },
  { name: 'New Order',      icon: 'ni ni-fat-add',          layout: LAYOUT, path: `${BASE}/orders/new`,          component: OrderCreatePage, invisible: true },
  { name: 'Order Detail',                                   layout: LAYOUT, path: `${BASE}/orders/:id`,           component: OrderDetailPage, invisible: true },
  { name: 'Edit Order',   layout: LAYOUT, path: `${BASE}/orders/:id/edit`, component: OrderEditPage, invisible: true },

  // Tanda Masuk
  { name: 'Tanda Masuk',    icon: 'ni ni-collection',       layout: LAYOUT, path: `${BASE}/documents/tanda-masuk`,   component: TandaMasukListPage },
  { name: 'Tanda Masuk + Invoice Detail', layout: '/app', path: '/sales/bagspa/documents/tanda-masuk/:id', component: TandaMasukDetailPage, invisible: true },

  // Payments
  { name: 'Payments',       icon: 'ni ni-credit-card',      layout: LAYOUT, path: `${BASE}/payments`,            component: PaymentsListPage },
  { name: 'Detail Payment',                                 layout: LAYOUT, path: `${BASE}/payments/:id`,   component: PaymentDetailPage, invisible: true },
  { name: 'Verify Payment',                                 layout: LAYOUT, path: `${BASE}/payments/verify/:id`,   component: PaymentVerifyPage, invisible: true },

  // Shipments
  { name: 'Shipments',      icon: 'ni ni-delivery-fast',    layout: LAYOUT, path: `${BASE}/shipments`,           component: ShipmentsListPage },
  { name: 'Shipment Detail',                                layout: LAYOUT, path: `${BASE}/shipments/:id`,        component: ShipmentDetailPage, invisible: true },

  // Audit Log QC
  { name: 'Audit Log QC',   icon: 'ni ni-books',            layout: LAYOUT, path: `${BASE}/audit-log/qc`,         component: AuditLogPage },

  // Admin Accounts
  {
    name: 'Admin Accounts',
    icon: 'ni ni-single-02',
    layout: LAYOUT,
    path: `${BASE}/admin-accounts`,
    component: AdminAccountsListPage,
    allowedRoles: ['superadmin']
  },
  {
    name: 'New Admin Account',
    layout: LAYOUT,
    path: `${BASE}/admin-accounts/new`,
    component: AdminAccountFormPage,
    invisible: true,
    allowedRoles: ['superadmin']
  },
  {
    name: 'Edit Admin Account',
    layout: LAYOUT,
    path: `${BASE}/admin-accounts/:id/edit`,
    component: AdminAccountFormPage,
    invisible: true,
    allowedRoles: ['superadmin']
  },

  // Documents
  { name: 'Surat Jalan',    icon: 'ni ni-book-bookmark',    layout: LAYOUT, path: `${BASE}/documents/surat-jalan`,   component: SuratJalanListPage },
  { name: 'Document Detail',        
                            layout: LAYOUT, path: `${BASE}/documents/:type/:id`,     component: DocumentDetailPage, invisible: true },
  // // Invoices
  { name: 'Invoices',       icon: 'ni ni-paper-diploma',    layout: LAYOUT, path: `${BASE}/documents/invoices`,      component: InvoicesListPage },

  // Taxonomy hub
  { name: 'Taxonomy',       icon: 'ni ni-settings-gear-65', layout: LAYOUT, path: `${BASE}/taxonomy`, component: TaxonomyPage },

  // Taxonomy → Brands
  { name: 'Brands',         layout: LAYOUT, path: `${BASE}/taxonomy/brands`,               component: BrandsListPage,  invisible: true },
  { name: 'New Brand',      layout: LAYOUT, path: `${BASE}/taxonomy/brands/new`,           component: BrandsFormPage,   invisible: true },
  { name: 'Edit Brand',     layout: LAYOUT, path: `${BASE}/taxonomy/brands/:id/edit`,      component: BrandsFormPage,   invisible: true },

  // Taxonomy → Categories
  { name: 'Categories',     layout: LAYOUT, path: `${BASE}/taxonomy/categories`,           component: CategoriesListPage,  invisible: true },
  { name: 'New Category',   layout: LAYOUT, path: `${BASE}/taxonomy/categories/new`,       component: CategoriesFormPage,   invisible: true },
  { name: 'Edit Category',  layout: LAYOUT, path: `${BASE}/taxonomy/categories/:id/edit`,  component: CategoriesFormPage,   invisible: true },

  // Taxonomy → Colours
  { name: 'Colours',        layout: LAYOUT, path: `${BASE}/taxonomy/colours`,              component: ColoursListPage,  invisible: true },
  { name: 'New Colour',     layout: LAYOUT, path: `${BASE}/taxonomy/colours/new`,          component: ColoursFormPage,   invisible: true },
  { name: 'Edit Colour',    layout: LAYOUT, path: `${BASE}/taxonomy/colours/:id/edit`,     component: ColoursFormPage,   invisible: true },

  // Taxonomy → Materials
  { name: 'Materials',        layout: LAYOUT, path: `${BASE}/taxonomy/materials`,              component: MaterialsListPage,  invisible: true },
  { name: 'New Material',     layout: LAYOUT, path: `${BASE}/taxonomy/materials/new`,          component: MaterialsFormPage,   invisible: true },
  { name: 'Edit Material',    layout: LAYOUT, path: `${BASE}/taxonomy/materials/:id/edit`,     component: MaterialsFormPage,   invisible: true },

  // Taxonomy → Sizes
  { name: 'Sizes',        layout: LAYOUT, path: `${BASE}/taxonomy/sizes`,             component: SizesListPage,  invisible: true },
  { name: 'New Size',     layout: LAYOUT, path: `${BASE}/taxonomy/sizes/new`,          component: SizesFormPage,   invisible: true },
  { name: 'Edit Size',    layout: LAYOUT, path: `${BASE}/taxonomy/sizes/:id/edit`,     component: SizesFormPage,   invisible: true },

  // --- Order Categories ---
  { name: 'Order Categories', layout: LAYOUT, path: `${BASE}/taxonomy/order_categories`, component: OrderCategoriesListPage, invisible: true },
  { name: 'New Order Category', layout: LAYOUT, path: `${BASE}/taxonomy/order_categories/new`, component: OrderCategoriesFormPage, invisible: true },
  { name: 'Edit Order Category', layout: LAYOUT, path: `${BASE}/taxonomy/order_categories/:id/edit`, component: OrderCategoriesFormPage, invisible: true },

  // Misc
  { name: 'New Customer',   icon: 'ni ni-circle-08',        layout: LAYOUT, path: `${BASE}/customers/new`, component: CustomerCreatePage, invisible: true },
]

export default bagspa_views
